// extracted by mini-css-extract-plugin
module.exports = {"white100":"#fff","primary":"#400099","primaryD10":"#2b0066","Fieldset":"medkit__Fieldset__Fieldset","FieldsetLegend":"medkit__Fieldset__FieldsetLegend"};